import { Component } from '@angular/core';

@Component({
  selector: 'app-museo',
  templateUrl: './museo.component.html',
  styleUrls: ['./museo.component.scss']
})
export class MuseoComponent {

}
